let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6ZETc"), load("KsAVd"), load("4aLlP"), load("6KGrg"), load("4hZJd")]).then(() => parcelRequire('leLdu'));